export const FOOD_ORDER_TYPE_ASPORTO = 'asporto';
export const FOOD_ORDER_TYPE_CONSEGNA = 'consegna';
export const FOOD_ORDER_TYPE_SEND_FRIENDS = 'shared';
export const FOOD_ORDER_REJECT_REASONS = {
    "ORDER_REJECT_REASON_BUSY": "Troppo occupato",
    "ORDER_REJECT_REASON_FAR_DELIVERY": "Luogo di consegna troppo lontano",
    "ORDER_REJECT_REASON_NO_DRIVER": "Alcune pietanze dell'ordine sono finite",
    "ORDER_REJECT_REASON_OUT_STOCK": "Consegna non disponibile al momento"
};
